<template>
  <el-dialog
    title="图库"
    width="80%"
    class="imgList avue-dialog"
    :close-on-click-modal="false"
    :visible.sync="imgVisible"
  >
    <el-tabs class="imgList__header menu__tabs" v-model="currentFileCategory">
      <el-tab-pane
        :key="item.name"
        v-for="(item, index) in fileCategory"
        :label="item.name"
        :name="String(index)"
      />
    </el-tabs>

    <div class="imgList__content">
      <el-upload
        list-type="picture"
        multiple
        class="imgList__border"
        :show-file-list="false"
        :action="fileUploadPath"
        :disabled="fileUploading"
        :headers="{
          Authorization: token,
        }"
        :on-success="onUploaded"
        :on-progress="onUploading"
      >
        <el-button
          :loading="fileUploading"
          size="small"
          icon="el-icon-upload"
          type="primary"
          >点击上传</el-button
        >
      </el-upload>
      <div class="imgList__border" :key="index" v-for="(item, index) in files">
        <img
          :src="item.uri"
          @click="onChange(item)"
          alt=""
          :draggable="false"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { url } from "@/config";
import store2 from "store2";
import { fetchFileCategoryList, fetchFileList } from "@/api/imgList";

export default {
  data() {
    return {
      imgVisible: false,
      currentFileCategory: 0, // 当前所在文件类型的索引
      fileCategory: [], // 文件类型
      files: [], // 文件
      fileUploading: false, // 文件是否上传中,
      token: null, // 用于上传图片时携带过去的token
      configFlag: "",
    };
  },
  computed: {
    /**
     * 当前分类Id
     */
    currentFileCategoryId() {
      return this.fileCategory?.[this.currentFileCategory]?.fileCategoryId;
    },
    /**
     * 文件上传接口路径
     */
    fileUploadPath() {
      const isDev = process.env.NODE_ENV === "development";
      // 不同环境的请求前缀
      const prefix = isDev ? "/api" : "/api";
      // 上传到指定的文件夹中
      const directory = "test_file";
      return `${prefix}${url}/file/upload?directory=${directory}&fileCategoryId=${this.currentFileCategoryId}`;
    },
  },
  watch: {
    currentFileCategory: {
      async handler() {
        this.files = await this.listFile(this.currentFileCategoryId);
      },
    },
  },
  async created() {
    this.token = store2.get("token");
    this.fileCategory = await this.listFileCategory();
  },
  methods: {
    openImg(flag) {
      this.imgVisible = true;
      this.configFlag = flag;
    },
    /**
     * 选中了某个图片
     * @param item 图片对象
     */
    onChange(item) {
      this.imgVisible = false;
      this.$emit("change", item.uri, this.configFlag);
    },
    /**
     * 获取文件类型列表
     */
    async listFileCategory() {
      const { data } = await fetchFileCategoryList({
        num: 999,
        page: 1,
      });
      return data?.data?.data || [];
    },
    /**
     * 获取文件列表
     * @param fileCategoryId 文件类型Id
     */
    async listFile(fileCategoryId) {
      const { data } = await fetchFileList({
        num: 999,
        page: 1,
        fileCategoryId,
      });
      return data?.data?.data || [];
    },
    /**
     * 文件上传中
     */
    onUploading() {
      this.fileUploading = true;
    },
    /**
     * 文件上传完成
     */
    async onUploaded() {
      this.fileUploading = false;
      this.files = await this.listFile(this.currentFileCategoryId);
    },
  },
};
</script>

<style lang="scss">
.imgList {
  .el-dialog__body {
    position: relative;
  }
  &__header {
    width: 100%;
    .el-tabs__item {
      min-width: 100px;
      text-align: center;
    }
  }
  &__content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  &__border {
    padding: 5px;
    width: 200px;
    height: 100px;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 5px;
    text-align: center;
    background-color: #333;
    .el-upload,
    .el-button {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
